import React, { useEffect } from 'react';
import Select from 'v3/components/Select';
import { Button, Text, Input } from 'v3/components';
import useQuery from 'hooks/useQuery';
import { useLocation, useNavigate } from 'react-router-dom';
import moment from 'moment';
import { Actions, Container, Field } from './styles';

const statusOptions = [
  { label: 'Atendida', slug: 'ATTENDANCE' },
  { label: 'Não atendida', slug: 'NOT_ATTENDANCE' },
];

export default function UnattendedLoadsFilter({
  loading,
  onChange,
  setAdvancedFilters,
  advancedFilters,
}) {
  const query = useQuery();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const nextSearch = query.toString();
    const currentSearch = (location.search || '').replace(/^\?/, '');
    if (nextSearch === currentSearch) return;

    const timeout = setTimeout(() => {
      navigate({ search: nextSearch }, { replace: true });
    }, 100);
    return () => clearTimeout(timeout);
  }, [advancedFilters, navigate, query, location.search]);

  return (
    <Container>

      <Field $minWidth="200px">
        <Input
          type="date"
          label="Data de carregamento de"
          labelColor="#fff"
          value={advancedFilters?.loadingStart || query.get('loadingStart')}
          onChange={event => {
            const value = event.target?.value;
            setAdvancedFilters(old => ({ ...old, loadingStart: value || null }));
            if (!value) {
              query.delete('loadingStart');
            } else {
              query.set('loadingStart', moment(value).format('YYYY-MM-DD'));
            }
          }}
        />
      </Field>

      <Field $minWidth="200px">
        <Input
          type="date"
          label="Data de carregamento até"
          labelColor="#fff"
          value={advancedFilters?.loadingEnd || query.get('loadingEnd')}
          onChange={event => {
            const value = event.target?.value;
            setAdvancedFilters(old => ({ ...old, loadingEnd: value || null }));
            if (!value) {
              query.delete('loadingEnd');
            } else {
              query.set('loadingEnd', moment(value).format('YYYY-MM-DD'));
            }
          }}
        />
      </Field>
      <Field $minWidth="220px">
        <Select
          label="Status"
          options={statusOptions}
          horizontal
          labelTextColor='white'
          modalHeading="Selecione um status"
          modalBodyTitle="Status:"
          placeholder="Selecione..."
          getOptionLabel={option => `${option?.label}`}
          getOptionValue={option => option?.slug}
          value={advancedFilters?.status}
          onChange={value => {
            if (value) {
              query.set('status', value.slug);
            } else {
              query.delete('status');
            }
            setAdvancedFilters(old => ({ ...old, status: value }));
          }}
        />
      </Field>
      <Actions>
        <Button variant="primary" loading={loading} onClick={() => onChange(advancedFilters)}>
          <Text color="white" weight={500}>Filtrar</Text>
        </Button>
      </Actions>
    </Container>
  );
}
